import { render } from "./CollectionDetails.vue?vue&type=template&id=3114a87d"
import script from "./CollectionDetails.vue?vue&type=script&lang=js"
export * from "./CollectionDetails.vue?vue&type=script&lang=js"
script.render = render

export default script